import { type Tenants } from '@gp/base'

import { apiClient } from '@/api/client'
import { type IGetOfferResponse } from '@/types/offer'

import type { GameIDs } from './types'

export const getOffer = async (
  network: Tenants,
  gameId: GameIDs = 'esum',
): Promise<IGetOfferResponse> => {
  const response = await apiClient.instance.get<IGetOfferResponse>(
    `/v1/${gameId}/offer`,
    { params: { network } },
  )
  return response.data
}
